(() => {
  'use strict';

  const selector = '[data-product-slider-article]';

  const isEnabled = (slider, name) => {
    const value = slider.dataset[name];
    return value === '' || value === 'true' || value === '1';
  };

  const init = () => {
    if (typeof Swiper === 'undefined') {
      window.setTimeout(init, 100);
      return;
    }

    document.querySelectorAll(selector).forEach((slider) => {
      if (slider.swiper) return;

      const pagination = slider.querySelector('.swiper-pagination');
      const nextButton = slider.querySelector('.swiper-button-next');
      const previousButton = slider.querySelector('.swiper-button-prev');
      const slideCount = slider.querySelectorAll('.swiper-slide').length;

      new Swiper(slider, {
        slidesPerView: 'auto',
        speed: 600,
        loop: slideCount > 1,
        spaceBetween: 0,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        pagination: isEnabled(slider, 'itemDots') && pagination
          ? { el: pagination, clickable: true }
          : false,
        navigation: isEnabled(slider, 'itemArrows') && nextButton && previousButton
          ? { nextEl: nextButton, prevEl: previousButton }
          : false
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();